import { Author, Upload, UploadItem, UploadMetadataType } from 'types/uploadType';
import {
  DELETE_UPLOAD_SUCCESS,
  EDIT_UPLOAD_ITEM,
  EDIT_UPLOAD_ITEM_FAILED,
  EDIT_UPLOAD_ITEM_SUCCESS,
  FIND_AUTHORS,
  FIND_AUTHORS_SUCCESS,
  GET_UPLOADS,
  GET_UPLOADS_FAILED,
  GET_UPLOADS_SUCCESS,
  POST_UPLOAD,
  POST_UPLOAD_FAILED,
  POST_UPLOAD_SUCCESS,
  PUBLISH_UPLOAD_ITEM,
  PUBLISH_UPLOAD_ITEM_FAILED,
  PUBLISH_UPLOAD_ITEM_SUCCESS,
  PUT_UPLOAD_ITEM,
  PUT_UPLOAD_ITEM_FAILED,
  PUT_UPLOAD_ITEM_SUCCESS,
  STOP_EDIT_UPLOAD_ITEM,
  SWITCH_UPLOAD_LIST_FILTER,
  SWITCH_UPLOAD_LIST_FILTER_FAILED,
  SWITCH_UPLOAD_LIST_FILTER_SUCCESS,
} from 'redux/constants';
import { GetUploadsPayload, GetUploadsSuccessPayload } from '@redux/actions/uploadActions';
import { UploadListFilter, UploadStateType } from 'types/stateTypes';

import { ActionType } from 'types/reduxTypes';
import { updateUploadItems } from 'redux/utils/uploadUtils';

const initialState: UploadStateType = {
  authors: [],
  isPublishing: false,
  loadingAuthors: false,
  loadingUploadItem: false,
  loadingUploads: false,
  savedUpload: false,
  savingUpload: false,
  uploads: [],
  uploadsHasMore: true,
};

export default (state = initialState, action: ActionType<unknown>): UploadStateType => {
  switch (action.type) {
    case EDIT_UPLOAD_ITEM: {
      return {
        ...state,
        editingUploadItem: undefined,
        loadingUploadItem: true,
        savedUpload: false,
        savingUpload: false,
      };
    }
    case EDIT_UPLOAD_ITEM_SUCCESS: {
      return {
        ...state,
        editingUploadItem: action.payload as UploadItem,
        loadingUploadItem: false,
      };
    }
    case EDIT_UPLOAD_ITEM_FAILED: {
      return {
        ...state,
        editingUploadItem: undefined,
        loadingUploadItem: false,
      };
    }
    case STOP_EDIT_UPLOAD_ITEM: {
      return {
        ...state,
        editingUploadItem: undefined,
        savedUpload: false,
      };
    }
    case POST_UPLOAD: {
      return {
        ...state,
        savedUpload: false,
        savingUpload: true,
      };
    }
    case PUBLISH_UPLOAD_ITEM: {
      return { ...state, isPublishing: true };
    }
    case PUBLISH_UPLOAD_ITEM_FAILED: {
      return { ...state, isPublishing: false };
    }
    case PUBLISH_UPLOAD_ITEM_SUCCESS: {
      const publishedUpload = action.payload as Upload;
      const newState = {
        ...state,
        editingUploadItem: {
          ...state.editingUploadItem,
          metadata: {
            ...(state?.editingUploadItem?.metadata as UploadMetadataType),
            id: publishedUpload?.items && publishedUpload.items[0].id,
          },
        } as UploadItem,
        isPublishing: false,
      };
      return newState;
    }
    case POST_UPLOAD_SUCCESS: {
      return {
        ...state,
        editingUploadItem: undefined,
        savedUpload: true,
        savingUpload: false,
        uploads: [action.payload as Upload, ...state.uploads],
      };
    }
    case POST_UPLOAD_FAILED: {
      return {
        ...state,
        savedUpload: false,
        savingUpload: false,
      };
    }
    case PUT_UPLOAD_ITEM: {
      return {
        ...state,
        savedUpload: false,
        savingUpload: true,
      };
    }
    case PUT_UPLOAD_ITEM_SUCCESS: {
      const editedItem = action.payload as Upload;
      const newUploads = updateUploadItems(state.uploads, editedItem);
      return {
        ...state,
        savedUpload: true,
        savingUpload: false,
        uploads: [...newUploads],
      };
    }
    case PUT_UPLOAD_ITEM_FAILED: {
      return {
        ...state,
        savedUpload: false,
        savingUpload: false,
      };
    }
    case GET_UPLOADS: {
      const { isAppend } = action.payload as GetUploadsPayload;
      return {
        ...state,
        loadingUploads: true,
        uploads: isAppend ? state.uploads : [],
        uploadsHasMore: true,
      };
    }
    case GET_UPLOADS_SUCCESS: {
      const { data, isAppend } = action.payload as GetUploadsSuccessPayload;
      if (isAppend) {
        if (data.length) return { ...state, loadingUploads: false, uploads: [...state.uploads, ...data] };
        else return { ...state, loadingUploads: false, uploadsHasMore: false };
      } else {
        return { ...state, loadingUploads: false, uploads: data };
      }
    }
    case GET_UPLOADS_FAILED: {
      return {
        ...state,
        loadingUploads: false,
      };
    }
    case DELETE_UPLOAD_SUCCESS: {
      const uploadId = action.payload as string;
      return { ...state, uploads: state.uploads.filter((e) => e.id !== uploadId) };
    }
    case FIND_AUTHORS: {
      return { ...state, loadingAuthors: true };
    }
    case FIND_AUTHORS_SUCCESS: {
      return { ...state, authors: action.payload as Author[], loadingAuthors: false };
    }
    case SWITCH_UPLOAD_LIST_FILTER: {
      return { ...state, filter: { catalogs: [], loading: true } };
    }
    case SWITCH_UPLOAD_LIST_FILTER_SUCCESS: {
      return { ...state, filter: action.payload as UploadListFilter };
    }
    case SWITCH_UPLOAD_LIST_FILTER_FAILED: {
      return { ...state, filter: { catalogs: [], loading: false } };
    }
    default: {
      return state;
    }
  }
};
